import { mutatorAction } from 'satcheljs';
import getStore from '../store/Store';

const updateCopilotPrioritizeOnboardedCalloutTargetMutator: (rowId: string) => void = mutatorAction(
    'updateCopilotPrioritizeOnboardedCalloutTarget',
    (rowId: string): void => {
        if (!getStore().copilotPrioritizeOnboardedCalloutTarget) {
            getStore().copilotPrioritizeOnboardedCalloutTarget = rowId;
        }
    }
);

export default updateCopilotPrioritizeOnboardedCalloutTargetMutator;
